const u = up.util;
up.MotionController = class MotionController {
    constructor(name) {
        this.finishEvent = `up:${name}:finish`;
        this._resetProps();
    }
    startFunction(newCluster, startMotionFn) {
        const nested = (this._startingCount > 0);
        if (!nested) {
            for (let newClusterElement of newCluster) {
                this.finish(newClusterElement);
            }
        }
        this._startingCount++;
        try {
            this._playingClusters.push(newCluster);
            let promise = up.error.muteUncriticalRejection(startMotionFn({ nested }));
            return promise.finally(() => u.remove(this._playingClusters, newCluster));
        }
        finally {
            this._startingCount--;
        }
    }
    finish(element = document.body) {
        for (let playingCluster of this._findPlayingClusters(element)) {
            u.remove(this._playingClusters, playingCluster);
            for (let playingElement of playingCluster) {
                this._emitFinishEvent(playingElement);
            }
        }
    }
    _findPlayingClusters(queryElement) {
        return this._playingClusters.filter((cluster) => {
            return u.some(cluster, (clusterElement) => queryElement.contains(clusterElement));
        });
    }
    _emitFinishEvent(element) {
        return up.emit(element, this.finishEvent, { log: false });
    }
    _resetProps() {
        this._startingCount = 0;
        this._playingClusters = [];
    }
    reset() {
        this.finish();
        this._resetProps();
    }
};
